import Header from "user/components/common/Header";
import { TermsProps } from "../TermsAndConditions";

type Props = {
    detail: TermsProps;
    setDetail: React.Dispatch<React.SetStateAction<TermsProps | null>>;
    onClickAgree: () => void;
};

export default function TermsDetail({ detail, setDetail, onClickAgree }: Props) {
    const { label, content } = detail;
    const title = label.slice(4, label.length);
    return (
        <div className="flex-1 flex flex-col absolute inset-0 bg-white">
            <Header title="이용약관" onClickClose={() => setDetail(null)} />
            <div className="wrapper py-[16px] flex-1 flex flex-col overflow-auto">
                <p className="font-bold text-[20px] leading-[30px] mb-[12px]">{title}</p>
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
            <div className="wrapper py-[16px]">
                <button
                    type="button"
                    onClick={onClickAgree}
                    className="bg-[#273219] w-full rounded-[12px] text-white text-[18px] leading-[28px] py-[12px] font-bold"
                >
                    동의하기
                </button>
            </div>
        </div>
    );
}
